function startGame() {
  gameScreen.draw();
}

var gameLogic = {};
gameLogic.selectedNumbers = [];
gameLogic.m = 4;
gameLogic.n = 3;
gameLogic.wildBonus = 25;
gameLogic.numbers = [];
gameLogic.currentLevel = 0;
gameLogic.maxLevel = 0;
gameLogic.lock = false;
gameLogic.shiftColLock = [];
for (var i = 0; i < gameLogic.n; i++) gameLogic.shiftColLock[i] = false;
gameLogic.shiftRowLock = [];
for (var i = 0; i < gameLogic.m; i++) gameLogic.shiftRowLock[i] = false;
gameLogic.shifting = false;
gameLogic.boardStates = [];
gameLogic.numOfSaveStates = 20;
gameLogic.stateIndex = 0;
gameLogic.bestScore = 0;
gameLogic.seenTutorial = false;
gameLogic.activePowerUps = [];
gameLogic.lastPowerUp = null;
gameLogic.PU_1to2 = 0;
gameLogic.PU_WILD = 1;
gameLogic.PU_SHIFT = 2;
gameLogic.PU_UNDO = 3;
gameLogic.powerUpName = ["PowerUp1to2", "PowerUpWild", "PowerUpShift", "LastChance"];

gameLogic.starValues = [];

gameLogic.drawIndex = 0;
gameLogic.drawDeck = [];
pushElements(gameLogic.drawDeck, 1, 10);
pushElements(gameLogic.drawDeck, 2, 4);
pushElements(gameLogic.drawDeck, 3, 1);
shuffleArray(gameLogic.drawDeck);
unshiftElements(gameLogic.drawDeck, 1, 5);

var expTexture;

var tutStartNumbers = [
  [1, 1],
  [2, 2],
  [1, 2],
  [-1, -1],
];
var tutEndNumbers = [
  [1, 2],
  [1, 2],
  [0, 2],
  [-1, -1],
];

var shapeColors = [primaryPalette[0], primaryPalette[1]];
var numberTextStyles = [];
numberTextStyles[0] = new PIXI.TextStyle({
  fontFamily: "manrope-medium",
  fontSize: 80,
  fill: [primaryPalette[1]],
  align: "center",
  //dropShadow: true,
  //dropShadowColor: ['#' + primaryPalette[3].toString(16)]
});
numberTextStyles[1] = new PIXI.TextStyle({
  fontFamily: "manrope-medium",
  fontSize: 80,
  fill: [primaryPalette[0]],
  align: "center",
  //dropShadow: true,
  //dropShadowColor: ['#' + primaryPalette[0].toString(16)]
});

gameLogic.levelCompleted = function () {
  gameLogic.lock = true;
  gameLogic.currentLevel++;
  gameLogic.maxLevel = Math.max(gameLogic.maxLevel, gameLogic.currentLevel);
  setTimeout(gameScreen.clearLevel, 1000);
  if (!levels[gameLogic.currentLevel]) gameLogic.generateLevel();

  setTimeout(gameScreen.drawLevel, 1500, levels[gameLogic.currentLevel]);
};

gameLogic.levelFailed = function () {
  if (gameLogic.activePowerUps[gameLogic.PU_UNDO] && gameLogic.moveCounter > gameLogic.numOfSaveStates * 2) {
    gameLogic.lock = true;
    gameLogic.gameOver = true;
    setTimeout(shakeScreen, 1000, 10, 1500, gameScreen.numbersContainer);
    setTimeout(playSound, 1000, "shake");
    setTimeout(gameScreen.openPowerUpInfo, 2500, gameLogic.PU_UNDO);
  } else {
    gameLogic.lock = true;
    gameLogic.gameOver = true;
    setTimeout(gameScreen.updatePowerUps, 500);
    setTimeout(shakeScreen, 1000, 5, 1500, gameScreen.numbersContainer);
    setTimeout(playSound, 1000, "shake");
    setTimeout(gameScreen.openGameOver, 2500);
    setTimeout(gameLogic.clearState, 50);
  }

  //gameScreen.lastScreenshot = captureScreen();
};

gameLogic.resetGame = function (shuffle) {
  if (shuffle == undefined) shuffle = true;

  gameLogic.moveCounter = 0;
  gameLogic.boardMax = 3;
  gameLogic.score = 0;
  gameLogic.updateScore(0);
  gameLogic.drawIndex = 0;
  if (shuffle) shuffleArray(gameLogic.drawDeck);
  gameLogic.setNextValue();
  gameLogic.lock = false;
  gameLogic.shiftColLock = [];
  for (var i = 0; i < gameLogic.n; i++) gameLogic.shiftColLock[i] = false;
  gameLogic.shiftRowLock = [];
  for (var i = 0; i < gameLogic.m; i++) gameLogic.shiftRowLock[i] = false;
  gameLogic.shifting = false;

  gameLogic.xGem = false;
  gameLogic.gameOver = false;
  gameLogic.activePowerUps = [true, true, true, true];
  gameLogic.lastPowerUp = null;
  gameScreen.updatePowerUps();
  //if (shuffle)
  //  gameScreen.hideLastChance();
};

gameLogic.saveState = function (replaceLastState) {
  var state = {};
  state.matrix = [];
  for (var i = 0; i < gameLogic.m; i++) {
    state.matrix[i] = [];
    for (var j = 0; j < gameLogic.n; j++) {
      state.matrix[i][j] = {};
      state.matrix[i][j].v = gameLogic.numbers[i][j].value;
      state.matrix[i][j].l = gameLogic.numbers[i][j].level;
    }
  }
  state.drawDeck = gameLogic.drawDeck;
  state.drawIndex = gameLogic.drawIndex;
  state.score = gameLogic.score;
  state.moveCounter = gameLogic.moveCounter;
  state.nextValue = gameLogic.nextValue;
  state.boardMax = gameLogic.boardMax;
  state.shifting = gameLogic.shifting;
  state.activePowerUps = gameLogic.activePowerUps;

  if (!replaceLastState) {
    for (var i = gameLogic.numOfSaveStates - 2; i >= 0; i--) {
      saveObject("state" + (i + 1), loadObject("state" + i));
    }
  }
  saveObject("state0", state);
};

gameLogic.loadState = function () {
  var bs = loadObject("bestScore");
  if (bs) {
    gameLogic.bestScore = bs;
    gameScreen.bestScoreText.text = gameLogic.bestScore + "";
  }

  var state = loadObject("state0");
  if (state) {
    gameLogic.boardMax = state.boardMax;
    gameLogic.nextValue = state.nextValue;
    gameScreen.updateNextValue(gameLogic.nextValue);
    gameLogic.score = state.score;
    gameLogic.moveCounter = state.moveCounter;
    gameLogic.updateScore(0);
    gameLogic.drawDeck = state.drawDeck;
    gameLogic.drawIndex = state.drawIndex;
    if (state.drawIndex > 0) {
      gameScreen.updateProgress((gameLogic.drawIndex - 1) / gameLogic.drawDeck.length);
    } else {
      gameScreen.updateProgress(1);
    }
    gameScreen.drawLevel(state, false);

    gameLogic.activePowerUps = state.activePowerUps;
    gameScreen.updatePowerUps();

    if (state.shifting) {
      gameLogic.startShifting();
    } else {
      if (!gameLogic.checkConditions()) {
        gameLogic.levelFailed();
      }
    }

    return true;
  } else return false;
};

gameLogic.revive = function () {
  saveObject("state0", loadObject("state" + (gameLogic.numOfSaveStates - 1)));
  gameLogic.loadState();
  gameLogic.activePowerUps[gameLogic.PU_UNDO] = false;
  gameLogic.lock = false;
};

gameLogic.clearState = function () {
  for (var i = 0; i < gameLogic.numOfSaveStates; i++) {
    localStorage.removeItem("state" + i);
    saveObject("state" + i, null);
  }
};

gameLogic.checkConditions = function () {
  var s = gameScreen;
  var markedNumbers = [];
  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      if (gameLogic.numbers[i][j]) {
        markedNumbers.push(gameLogic.numbers[i][j]);
        j = gameLogic.numbers[i].length;
        i = gameLogic.numbers.length;
      }
    }
  }
  var validMove = false;
  for (var i = 0; i < markedNumbers.length; i++) {
    var neig = markedNumbers[i].getNeighbours();
    var len = neig.length;
    for (var j = 0; j < len; j++) {
      if (markedNumbers.indexOf(neig[j]) == -1) {
        markedNumbers.push(neig[j]);
      }
      if (!validMove) {
        if (markedNumbers[i].canCapture(neig[j])) validMove = true;
      }
    }
  }

  return validMove;
};

gameLogic.isThereHope = function () {
  if (gameLogic.activePowerUps[gameLogic.PU_SHIFT]) return true;

  if (gameLogic.activePowerUps[gameLogic.PU_1to2]) {
    for (var i = 0; i < gameLogic.m; i++) {
      for (var j = 0; j < gameLogic.n; j++) {
        if (gameLogic.numbers[i][j].value == 1) {
          var neig = gameLogic.numbers[i][j].getNeighbours();
          var len = neig.length;
          for (var k = 0; k < len; k++) {
            if (neig[k].value == 2) return true;
          }
        }
      }
    }
  }

  return false;
};

gameLogic.resetLevel = function () {
  gameLogic.selectedNumbers = [];
  gameLogic.numbers = [];
  gameLogic.lock = false;
};

gameLogic.updateLevel = function () {
  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      if (gameLogic.numbers[i][j]) {
        gameLogic.numbers[i][j].update();
      }
    }
  }
};

gameLogic.moveNumber = function (nums) {
  gameLogic.lock = true;
  nums[0].parent.toFront(nums[0]);
  if (tutorial.isDrawn) {
    tutorial.handContainer.parent.toFront(tutorial.handContainer);
  }
  var neig = nums[0].getNeighbours();

  for (var j = 0; j < neig.length; j++) {
    gameScreen.updateDots(nums[0], neig[j], false, false);
  }
  gameLogic.numbers[nums[0].i][nums[0].j] = null;
  var len = nums.length;
  var ease;
  for (var i = 1; i < len; i++) {
    if (len == 2) {
      ease = Power1.easeInOut;
    } else {
      ease = Power0.easeNone;
      if (i == 1) ease = Power1.easeIn;
      if (i == len - 1) ease = Power1.easeOut;
    }

    TweenMax.to(nums[0], 0.2, {
      pixi: {
        x: nums[i].x,
        y: nums[i].y,
      },
      delay: (i - 1) * 0.2,
      ease: ease,
    });

    TweenMax.to(nums[i].gemSprite, 0.2, {
      pixi: {
        scale: 0.5,
      },
      delay: (i - 1) * 0.2,
      ease: Power2.easeOut,
      onComplete: function (nums, i) {
        if (i < nums.length - 1) {
          var neig = nums[i].getNeighbours();
          //                    for (var j = 0; j < neig.length; j++) {
          //                        gameScreen.updateDots(nums[i], neig[j], false, false);
          //                    }
          gameLogic.numbers[nums[i].i][nums[i].j] = null;
        }

        if (nums[i].tween) nums[i].tween.kill();

        var newI = nums[0].i;
        var newJ = nums[0].j;
        gameLogic.numbers[newI][newJ] = new NumberShape(gameScreen.numbersContainer, gameLogic.nextValue);
        gameLogic.numbers[newI][newJ].position = gameScreen.getNumberPos(newI, newJ);
        gameLogic.numbers[newI][newJ].i = newI;
        gameLogic.numbers[newI][newJ].j = newJ;
        gameLogic.numbers[newI][newJ].upDots = nums[0].upDots;
        gameLogic.numbers[newI][newJ].rightDots = nums[0].rightDots;
        gameLogic.numbers[newI][newJ].downDots = nums[0].downDots;
        gameLogic.numbers[newI][newJ].leftDots = nums[0].leftDots;
        gameLogic.numbers[newI][newJ].scale.set(0.5);
        gameLogic.numbers[newI][newJ].alpha = 0;

        //new number appears
        TweenMax.to(gameLogic.numbers[newI][newJ], 0.2, {
          pixi: {
            scale: 1,
            alpha: 1,
          },
          delay: 0.4,
          ease: Power2.easeOut,
        });

        nums[0].parent.toFront(nums[0]);
        if (tutorial.isDrawn) {
          tutorial.handContainer.parent.toFront(tutorial.handContainer);
        }

        if (nums[0].value + nums[i].value > 0) {
          var newValue = Math.max(nums[0].value, nums[i].value) + 1;
          nums[0].value = newValue;
          nums[0].level = 0;
          gameLogic.updateScore((newValue - 1) * (newValue - 1));
          if (newValue == 11) {
            gameLogic.lock = true;
            gameLogic.gameOver = true;
            setTimeout(gameLogic.clearState, 50);
            setTimeout(gameScreen.openWin, 500, nums[0].value, nums[0].level, nums[i].i, nums[i].j);
            nums[0].change(-1, 0);
          } else {
            nums[0].change(newValue, 0);
          }
        } else {
          var newLevel = nums[0].level + 1;
          gameLogic.updateScore(newLevel * newLevel * gameLogic.wildBonus);
          nums[0].value = 0;
          nums[0].level = newLevel;

          if (newLevel == 3) {
            gameLogic.lock = true;
            gameLogic.gameOver = true;
            setTimeout(gameLogic.clearState, 50);
            setTimeout(gameScreen.openWin, 500, nums[0].value, nums[0].level, nums[i].i, nums[i].j);
            nums[0].change(-1, 0);
          } else {
            nums[0].change(0, newLevel);
          }
        }

        if (i == nums.length - 1) {
          nums[0].i = nums[i].i;
          nums[0].j = nums[i].j;
          nums[0].upDots = nums[i].upDots;
          nums[0].rightDots = nums[i].rightDots;
          nums[0].downDots = nums[i].downDots;
          nums[0].leftDots = nums[i].leftDots;
          gameLogic.numbers[nums[i].i][nums[i].j] = nums[0];
          nums[i].delete();
          gameLogic.updateLevel();
          if (!gameLogic.gameOver) {
            if (!gameLogic.checkConditions()) {
              gameLogic.levelFailed();
            }
          }
          gameLogic.selectedNumbers = [];
        } else {
          nums[i].delete();
        }

        gameLogic.setNextValue();
        if (tutorial.isDrawn) {
          tutorial.nextStep();
        } else {
          if (!gameLogic.gameOver) gameLogic.saveState();
        }
      },
      onCompleteParams: [nums, i],
    });
  }
};

gameLogic.unselectAll = function () {
  for (var i = 0; i < gameLogic.selectedNumbers.length; i++) {
    if (gameLogic.selectedNumbers[i]) gameLogic.selectedNumbers[i].unselect();
  }
  gameScreen.disconnectDots(gameLogic.selectedNumbers);
  gameLogic.selectedNumbers = [];
};

gameLogic.setNextValue = function () {
  gameLogic.moveCounter++;

  if (gameLogic.drawIndex >= gameLogic.drawDeck.length) {
    gameLogic.nextValue = 0;
    shuffleArray(gameLogic.drawDeck);
    gameScreen.updateProgress(gameLogic.drawIndex / gameLogic.drawDeck.length);
    gameLogic.drawIndex = 0;
  } else {
    gameLogic.nextValue = gameLogic.drawDeck[gameLogic.drawIndex];
    gameScreen.updateProgress(gameLogic.drawIndex / gameLogic.drawDeck.length);
    gameLogic.drawIndex++;
  }

  gameScreen.updateNextValue(gameLogic.nextValue);
};

gameLogic.powerUp1to2 = function () {
  var delay = 0;
  var delayInc = 0.1;
  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      if (gameLogic.numbers[i][j].value == 1) {
        gameLogic.numbers[i][j].value = 2;
        gameLogic.numbers[i][j].change(2, 0, false, delay);
        delay += delayInc;
        setTimeout(playSound, delay * 1000, "scoreCount");
      }
    }
  }

  gameLogic.saveState(true);
  if (!gameLogic.checkConditions()) {
    gameLogic.levelFailed();
  } else {
    setTimeout(function () {
      gameLogic.lock = false;
    }, delay * 1000);
  }
};

gameLogic.powerUpWild = function () {
  gameLogic.nextValue = 0;
  gameScreen.updateNextValue(0);
  setTimeout(function () {
    var e = new Waves(gameScreen.nextNumContainer, 75, 3, 3, 1, [0x000000]);
    e.alpha = 0.25;
    gameScreen.nextNumContainer.toBack(e);
    for (var i = 0; i < 3; i++) {
      setTimeout(playSound, 100 + i * 300, "match" + (i + 1));
      setTimeout(playSound, 100 + i * 300, "match" + (i + 2));
      setTimeout(playSound, 100 + i * 300, "match" + (i + 3));
    }
  }, 500);

  gameLogic.saveState(true);
  gameLogic.lock = false;
};

gameLogic.shiftColumn = function (col, dir) {
  if (gameLogic.shiftColLock[col]) {
    setTimeout(gameLogic.shiftColumn, 50, col, dir);
    return;
  }

  gameLogic.shiftColLock[col] = true;

  if (dir > 0) {
    var p = gameLogic.numbers[gameLogic.m - 1][col];
    var pVars = {};
    gameLogic.fixNumber(pVars, gameLogic.numbers[0][col]);
  } else {
    var p = gameLogic.numbers[0][col];
    var pVars = {};
    gameLogic.fixNumber(pVars, gameLogic.numbers[gameLogic.m - 1][col]);
  }

  for (var k = 0; k < gameLogic.m - 1; k++) {
    var i = k;
    if (dir < 0) i = gameLogic.m - k - 1;

    gameLogic.fixNumber(gameLogic.numbers[i][col], gameLogic.numbers[i + dir][col]);
  }

  for (var k = gameLogic.m - 2; k >= 0; k--) {
    var i = k;
    if (dir < 0) i = gameLogic.m - k - 1;

    gameLogic.numbers[i + dir][col] = gameLogic.numbers[i][col];
    var newPos = gameScreen.getNumberPos(i + dir, col);
    TweenMax.to(gameLogic.numbers[i + dir][col], 0.1, {
      pixi: {
        x: newPos.x,
        y: newPos.y,
      },
      ease: Power2.easeOut,
      delay: 0.05,
    });
  }

  gameLogic.fixNumber(p, pVars);
  if (dir > 0) {
    var newPos = gameScreen.getNumberPos(0, col);
    gameLogic.numbers[0][col] = p;
  } else {
    var newPos = gameScreen.getNumberPos(gameLogic.m - 1, col);
    gameLogic.numbers[gameLogic.m - 1][col] = p;
  }

  TweenMax.to(p, 0.1, {
    pixi: {
      scale: 0.75,
      alpha: 0,
    },
    ease: Back.easeIn.config(1),
    onComplete: function () {
      p.position.set(newPos.x, newPos.y);
      TweenMax.to(p, 0.1, {
        pixi: {
          scale: 1,
          alpha: 1,
        },
        ease: Back.easeOut.config(1),
        onComplete: function () {
          gameLogic.shiftColLock[col] = false;
        },
      });
    },
  });

  gameLogic.saveState(true);

  if (!gameLogic.checkConditions()) {
    gameScreen.disableShiftDone();
  } else {
    gameScreen.enableShiftDone();
  }
};

gameLogic.shiftRow = function (row, dir) {
  if (gameLogic.shiftRowLock[row]) {
    setTimeout(gameLogic.shiftRow, 50, row, dir);
    return;
  }

  gameLogic.shiftRowLock[row] = true;

  if (dir > 0) {
    var p = gameLogic.numbers[row][gameLogic.n - 1];
    var pVars = {};
    gameLogic.fixNumber(pVars, gameLogic.numbers[row][0]);
  } else {
    var p = gameLogic.numbers[row][0];
    var pVars = {};
    gameLogic.fixNumber(pVars, gameLogic.numbers[row][gameLogic.n - 1]);
  }

  for (var k = 0; k < gameLogic.n - 1; k++) {
    var j = k;
    if (dir < 0) j = gameLogic.n - k - 1;

    gameLogic.fixNumber(gameLogic.numbers[row][j], gameLogic.numbers[row][j + dir]);
  }

  for (var k = gameLogic.n - 2; k >= 0; k--) {
    var j = k;
    if (dir < 0) j = gameLogic.n - k - 1;

    gameLogic.numbers[row][j + dir] = gameLogic.numbers[row][j];
    var newPos = gameScreen.getNumberPos(row, j + dir);
    TweenMax.to(gameLogic.numbers[row][j + dir], 0.1, {
      pixi: {
        x: newPos.x,
        y: newPos.y,
      },
      ease: Power2.easeOut,
      delay: 0.05,
    });
  }

  gameLogic.fixNumber(p, pVars);
  if (dir > 0) {
    var newPos = gameScreen.getNumberPos(row, 0);
    gameLogic.numbers[row][0] = p;
  } else {
    var newPos = gameScreen.getNumberPos(row, gameLogic.n - 1);
    gameLogic.numbers[row][gameLogic.n - 1] = p;
  }

  TweenMax.to(p, 0.1, {
    pixi: {
      scale: 0.75,
      alpha: 0,
    },
    ease: Back.easeIn.config(1),
    onComplete: function () {
      p.position.set(newPos.x, newPos.y);
      TweenMax.to(p, 0.1, {
        pixi: {
          scale: 1,
          alpha: 1,
        },
        ease: Back.easeOut.config(1),
        onComplete: function () {
          gameLogic.shiftRowLock[row] = false;
        },
      });
    },
  });

  gameLogic.saveState(true);
  if (!gameLogic.checkConditions()) {
    gameScreen.disableShiftDone();
  } else {
    gameScreen.enableShiftDone();
  }
};

gameLogic.startShifting = function () {
  if (gameLogic.shifting) return;

  gameLogic.shifting = true;
  gameLogic.lock = true;
  gameScreen.showShiftButtons();
  gameLogic.saveState();

  if (!gameLogic.checkConditions()) {
    gameScreen.disableShiftDone();
  } else {
    gameScreen.enableShiftDone();
  }

  //gameScreen.hideLastChance(false);
};

gameLogic.stopShifting = function () {
  if (!gameLogic.shifting) return;

  gameLogic.lock = false;
  gameLogic.shifting = false;
  gameScreen.hideShiftButtons();
  gameLogic.saveState(true);
};

gameLogic.rewardPlayer = function () {
  if (gameLogic.lastPowerUp == gameLogic.PU_1to2) {
    gameLogic.activePowerUps[0] = false;
    gameScreen.updatePowerUps();
    //gameScreen.hideLastChance();
    setTimeout(gameLogic.powerUp1to2, 1000);
  }
  if (gameLogic.lastPowerUp == gameLogic.PU_WILD) {
    gameLogic.activePowerUps[1] = false;
    gameScreen.updatePowerUps();
    setTimeout(gameLogic.powerUpWild, 1000);
  }
  if (gameLogic.lastPowerUp == gameLogic.PU_SHIFT) {
    gameLogic.startShifting();
    gameScreen.updatePowerUps();
  }

  if (gameLogic.lastPowerUp == gameLogic.PU_UNDO) {
    gameLogic.gameOver = false;
    gameScreen.clearLevel(true);
  }

  analyticsCustiomEvent(gameLogic.powerUpName[gameLogic.lastPowerUp]);
};

gameLogic.fixNumber = function (num, newNum) {
  num.i = newNum.i;
  num.j = newNum.j;
  num.upDots = newNum.upDots;
  num.downDots = newNum.downDots;
  num.rightDots = newNum.rightDots;
  num.leftDots = newNum.leftDots;
};

gameLogic.updateScore = function (inc) {
  if (gameLogic.score < 6000 && gameLogic.score + inc >= 6000) {
    //6000 achievement
  }
  gameLogic.score += inc;
  gameScreen.scoreText.text = gameLogic.score + "";

  if (gameLogic.score >= gameLogic.bestScore) {
    gameLogic.bestScore = gameLogic.score;
    gameScreen.bestScoreText.text = gameLogic.bestScore + "";
    saveObject("bestScore", gameLogic.bestScore);
  }
};

function NumberShape(parent, value, level) {
  var t = new Container(parent);
  t.value = value;
  level = level || 0;
  t.level = level;
  t.lock = false;

  if (gameLogic.boardMax < value && gameScreen.root.visible) {
    gameLogic.boardMax = value;
    analyticsCustiomEvent("New gem: " + value);
    if (value < 11) gameLogic.saveState();

    if (window.JSInterface != undefined) {
      window.JSInterface.unlockAchievement("gem" + value);
    }

    if (expTexture == undefined) {
      var rect = new Rectangle(t, [20, 3]);
      expTexture = rect.texture;
      rect.destroy();
    }

    ads.happyTime(value / 11);
    var numOfExp = value;
    if (value == 11) {
      numOfExp = 44;
    } else {
      for (var i = 0; i < value; i++) {
        setTimeout(playSound, 350 + i * 150, "match" + (i + 1));
        setTimeout(playSound, 350 + i * 150, "match" + (i + 5));
      }
    }
    for (var i = 0; i < numOfExp; i++) {
      setTimeout(
        function (par, tex, angle) {
          if (par) {
            if (par.value < 11) {
              //setTimeout(playSound,random(100),"fireworks"+(random(3)+1));
            }
            var e = new Explosion(par, 150, tex, par.value, 0.5, [gemColors[par.value]]);
            par.toBack(e);
            if (par.star.parent == par) par.toBack(par.star);
            e.rotation = degToRad(angle);
          }
        },
        300 + i * 150,
        t,
        expTexture,
        (i * 180) / value
      );
    }

    t.star = new Star(t, [120 + 5 * value, 30], value * 3);
    t.toBack(t.star);
    t.star.scale.set(0.5);
    t.star.alpha = 0;
    TweenMax.to(t.star, 0.3, {
      pixi: {
        scale: 1,
        alpha: 0.75,
      },
      ease: Power2.easeOut,
      delay: 0.15,
    });
    TweenMax.to(t.star, 0.8 + value * 0.15, {
      pixi: {
        rotation: value * 2.5,
      },
      ease: Power2.easeInOut,
    });
    TweenMax.to(t.star, 0.6, {
      pixi: {
        scale: 0,
        alpha: 0,
      },
      ease: Power2.easeIn,
      delay: 0.65 + value * 0.15,
      onComplete: function (s) {
        s.delete();
      },
      onCompleteParams: [t.star],
    });
  }
  if (value == 0 && level > 0 && !gameLogic.xGem && gameScreen.root.visible) {
    if (window.JSInterface != undefined) {
      window.JSInterface.unlockAchievement("wild" + level);
    }

    if (level < 3) {
      for (var i = 0; i < 3; i++) {
        setTimeout(playSound, 0 + i * 300, "match" + (i + level * 3 + 1));
        setTimeout(playSound, 0 + i * 300, "match" + (i + level * 3 + 2));
        setTimeout(playSound, 0 + i * 300, "match" + (i + level * 3 + 3));
      }
    }
    setTimeout(
      function (par) {
        if (par) {
          var numOfWaves = par.level + 2;
          if (par.level == 3) {
            gameLogic.xGem = true;
            numOfWaves = 30;
          }

          var e = new Waves(par, 130, 3, numOfWaves, 1, [wildColors[par.level]]);
          e.alpha = 0.5;
          par.toBack(e);
        }
      },
      250,
      t
    );
  }

  t.btnArea = new Circle(t, 150);
  var lineW = 5;

  if (value > 0) {
    t.gemSprite = new Sprite(t, "gem" + value + ".png");
    t.badgeSprite = new Sprite(t, "badge" + value + ".png");
  } else {
    t.gemSprite = new Sprite(t, "gem0_" + level + ".png");

    t.badgeSprite = new Sprite(t, "badge0_" + level + ".png");
  }

  t.badgeSprite.y += 120;
  t.backLine = new Circle(t, 100, [lineW, 0xffffff, 1], [0xffffff, 0]);

  t.update = function () {};

  //t.gemSprite.tint = shapeColors[1];
  t.backLine.tint = shapeColors[1];
  t.backLine.alpha = 0;
  t.btnArea.alpha = 0;
  //    t.dust = new ShapeDust(t, 7, 2, primaryPalette, 1);
  //    t.dust.mask = t.btnArea;
  //    t.dust.reset();
  //    t.dust.reset();

  var rot = degToRad(0);
  t.numberText = new Text(t, "" + t.value, numberTextStyles[1]);
  t.numberText.alpha = 0;
  t.numberText.rotation = rot;

  //    t.numberText.delete = function () {
  //        if (this.tween)
  //            this.tween.kill();
  //        this.parent.removeChild(this);
  //        this.destroy(true);
  //    }

  t.select = function (head) {
    if (this.lock || gameLogic.lock) return;

    if (this.selectTween) this.selectTween.kill();

    if (head) {
      playSound("selectGem");
      this.selectTween = TweenMax.to(this.gemSprite, 0.1, {
        pixi: {
          scale: 1.15,
        },
        ease: Power2.easeOut,
      });
    } else {
      playSound("selectGem");
      this.selectTween = TweenMax.to(this.gemSprite, 0.1, {
        pixi: {
          scale: 0.9,
        },
        ease: Power2.easeOut,
      });
    }
  };

  t.unselect = function () {
    if (t.lock || gameLogic.lock) return;

    if (this.selectTween) this.selectTween.kill();

    this.selectTween = TweenMax.to(this.gemSprite, 0.1, {
      pixi: {
        scale: 1,
      },
      delay: 0.1,
      ease: Power2.easeIn,
    });
  };

  t.canCapture = function (numberObj) {
    if (this.value * numberObj.value == 0) {
      var lvl;
      if (this.value + numberObj.value == 0) {
        return this.level == numberObj.level;
      }

      if (this.value == 0) lvl = this.level;
      else lvl = numberObj.level;

      var min = lvl * 3 + 1;
      var max = lvl * 3 + 3;
      return this.value + numberObj.value >= lvl * 3 + 1 && this.value + numberObj.value <= lvl * 3 + 3;
    } else {
      return this.value == numberObj.value;
    }
  };
  t.getNeighbours = function () {
    var neig = [];

    var i = this.i;
    var j = this.j;

    if (j < gameLogic.n - 1) if (gameLogic.numbers[i][j + 1]) neig.push(gameLogic.numbers[i][j + 1]);
    if (j > 0) if (gameLogic.numbers[i][j - 1]) neig.push(gameLogic.numbers[i][j - 1]);
    if (i < gameLogic.m - 1) if (gameLogic.numbers[i + 1][j]) neig.push(gameLogic.numbers[i + 1][j]);
    if (i > 0) if (gameLogic.numbers[i - 1][j]) neig.push(gameLogic.numbers[i - 1][j]);

    return neig;
  };

  t.change = function (newValue, newLevel, withSound, delay) {
    gameLogic.lock = true;
    if (withSound == undefined) withSound = true;

    delay = delay || 0;

    if (newValue == -1) {
      TweenMax.to(this.badgeSprite, 0.2, {
        pixi: {
          scale: 0.75,
          alpha: 0,
        },
        delay: 0.1,
        ease: Back.easeIn.config(1),
      });
    }
    TweenMax.to(this.gemSprite, 0.2, {
      pixi: {
        scale: 0.75,
        alpha: 0,
      },
      ease: Back.easeIn.config(1),
      delay: delay,
      onComplete: function (num, value, level) {
        if (value == -1) {
          return;
        }
        var newNum = new NumberShape(num.parent, value, level);
        newNum.i = num.i;
        newNum.j = num.j;
        newNum.x = num.x;
        newNum.y = num.y;
        newNum.upDots = num.upDots;
        newNum.leftDots = num.leftDots;
        newNum.downDots = num.downDots;
        newNum.rightDots = num.rightDots;
        newNum.badgeSprite.rotation = degToRad(0);
        newNum.badgeSprite.scale.set(1);
        newNum.gemSprite.scale.set(0.75);
        newNum.gemSprite.alpha = 0.5;
        gameLogic.numbers[num.i][num.j] = newNum;
        if (num.tween) num.tween.kill();

        num.delete();

        if (newValue > 0 && withSound) {
          var tone3 = newValue + 3;
          var tone2 = tone3 - 1 - random(2);
          var tone1 = tone2 - 1;
          playSound("match" + tone1);
          setTimeout(playSound, 50, "match" + tone2);
          setTimeout(playSound, 100, "match" + tone3);
        }
        TweenMax.to(newNum.badgeSprite, 0.2, {
          pixi: {
            rotation: 0,
            scale: 1,
          },
          ease: Back.easeOut.config(1),
        });

        TweenMax.to(newNum.gemSprite, 0.2, {
          pixi: {
            //rotation: 360,
            scale: 1,
            alpha: 1,
          },
          ease: Back.easeOut.config(1),
          onComplete: function () {
            if (!gameLogic.gameOver) {
              gameLogic.lock = false;
            }
          },
        });
      },
      onCompleteParams: [this, newValue, newLevel],
    });
  };

  t.onPointerDown = function (e) {
    if (tutorial.isDrawn) {
      if (this.i != tutStartNumbers[tutorial.currentStep][0] || this.j != tutStartNumbers[tutorial.currentStep][1]) return;
    }

    if (gameLogic.lock) return;

    if (e.data.originalEvent.touches) if (e.data.originalEvent.touches.length > 1) return;

    gameLogic.selectedNumbers = [];
    gameLogic.selectedNumbers.push(this);
    this.select(true);
  };

  t.onPointerMove = function (e) {
    if (tutorial.isDrawn) {
      if (this.i != tutEndNumbers[tutorial.currentStep][0] || this.j != tutEndNumbers[tutorial.currentStep][1]) return;
    }

    if (gameLogic.lock) return;

    var sLen = gameLogic.selectedNumbers.length;
    if (sLen == 0) return;

    var lastS = gameLogic.selectedNumbers[gameLogic.selectedNumbers.length - 1];

    var neig = gameLogic.selectedNumbers[sLen - 1].getNeighbours();

    if (gameLogic.selectedNumbers.indexOf(this) == -1 && neig.indexOf(this) != -1 && gameLogic.selectedNumbers[0].canCapture(this)) {
      if (sLen == 2) return;

      gameLogic.selectedNumbers.push(this);
      this.select(false);
      gameScreen.updateDots(gameLogic.selectedNumbers[sLen - 1], this, true, false);
      return;
    }

    if (gameLogic.selectedNumbers.indexOf(this) == sLen - 2 && sLen > 1) {
      gameScreen.updateDots(gameLogic.selectedNumbers[sLen - 1], this, false, false);
      gameLogic.selectedNumbers.pop().unselect();
    }
  };

  t.onPointerUp = function (e) {
    if (gameLogic.lock) return;

    if (e.data.originalEvent.touches) if (e.data.originalEvent.touches.length > 0) return;

    var sLen = gameLogic.selectedNumbers.length;
    if (sLen > 0) gameLogic.selectedNumbers[0].unselect();

    if (sLen > 1) {
      gameLogic.moveNumber(gameLogic.selectedNumbers);
    } else {
      gameLogic.selectedNumbers = [];
    }
  };

  if (tutorial.isDrawn) {
    tutorial.handContainer.parent.toFront(tutorial.handContainer);
  }

  t.buttonMode = true;
  t.interactive = true;
  t.on("pointerdown", t.onPointerDown);
  t.on("pointermove", t.onPointerMove);
  t.on("pointerup", t.onPointerUp);

  t.rotation = -t.parent.rotation;

  return t;
}
